import { useTranslation } from 'react-i18next';
import {
  Card,
  ModalComponentWrapper,
  UserProfileAction,
} from '@/shared/components';
import DocumentIcon from '@/shared/assets/document-icon.svg?react';
import { useMyDocumentsModal } from '../model';
import { useGenerateIncomeStatementModal } from '@/features/user-profile-generate-income-statement';
import { useGenerateStatementModal } from '@/features/generate-statement';
import { usePaidInvoicesModal } from '@/features/user-profile-paid-invoices';
import { useVerificationInfoModal } from '@/entities/verification';

interface Props {
  onBack: () => void;
  isUserVerified: boolean;
}

const MyDocumentsModal = ({ onBack, isUserVerified }: Props) => {
  const { t } = useTranslation();

  const { openVerificationInfoModal } = useVerificationInfoModal();
  const { openMyDocumentsModal } = useMyDocumentsModal();

  const { openGenerateIncomeStatementModal } =
    useGenerateIncomeStatementModal();
  const { openGenerateStatementModal } = useGenerateStatementModal();
  const { openPaidInvoicesModal } = usePaidInvoicesModal();

  const openDocsModal = () => openMyDocumentsModal({ onBack, isUserVerified });

  const verify = (title: string, fn: () => void) => {
    if (!isUserVerified) {
      openVerificationInfoModal({
        title,
        onBack: openDocsModal,
        dialogClassName: 'max-h-[38.4rem]',
      });
      return;
    }

    fn();
  };

  const openIncomeStatementModal = () => {
    openGenerateIncomeStatementModal({
      onBack: openDocsModal,
    });
  };

  const openStatementModal = () =>
    openGenerateStatementModal({ onBack: openDocsModal });

  const openPaidInvoices = () =>
    openPaidInvoicesModal({ onBack: openDocsModal });

  return (
    <ModalComponentWrapper
      title={t('personalAccount.userProfile.myDocuments.title')}
      onBack={onBack}
      headerClassName="text-secondary-bg bg-secondary-bg/50">
      <Card className="p-[0.8rem] rounded-[1.6rem] w-full shadow-none flex flex-col gap-2">
        <UserProfileAction
          icon={<DocumentIcon className="size-10 text-primary" />}
          title={t(
            'personalAccount.userProfile.myDocuments.incomeStatement.generateButtonText'
          )}
          onClick={() =>
            verify(
              t(
                'personalAccount.userProfile.myDocuments.incomeStatement.title'
              ),
              openIncomeStatementModal
            )
          }
        />
        <UserProfileAction
          icon={<DocumentIcon className="size-10 text-primary" />}
          title={t(
            'personalAccount.userProfile.myDocuments.statement.generateButtonText'
          )}
          onClick={() =>
            verify(
              t('personalAccount.userProfile.myDocuments.statement.title'),
              openStatementModal
            )
          }
        />
        <UserProfileAction
          icon={<DocumentIcon className="size-10 text-primary" />}
          title={t(
            'personalAccount.userProfile.myDocuments.paidInvoices.menuItem'
          )}
          onClick={() =>
            verify(
              t('personalAccount.userProfile.myDocuments.paidInvoices.title'),
              openPaidInvoices
            )
          }
        />
      </Card>
    </ModalComponentWrapper>
  );
};

export { MyDocumentsModal };
